module.exports = __webpack_public_path__ + "assets/img/loading.95cafdb0.gif";